import { createSlice } from '@reduxjs/toolkit';

import { getElhaghiyehMenuContents } from 'Feature/Common/Common/Actions/Thunks/getElhaghiyehMenuContents';
import { getMenuContentById } from 'Feature/Common/Common/Actions/Thunks/getMenuContentById';

import { IContentPageState } from './model';

const initialState: IContentPageState = {
  loading: false,
  data: {},
  elhaghiyehMenuContents: {
    data: [],
    loading: false,
  },
};
export const contentPageSlice = createSlice({
  name: 'landing/MainPage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMenuContentById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMenuContentById.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload !== undefined) {
          state.data = action.payload;
        }
        return state;
      })
      .addCase(getMenuContentById.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(getElhaghiyehMenuContents.pending, (state) => {
        state.elhaghiyehMenuContents.loading = true;
      })
      .addCase(getElhaghiyehMenuContents.fulfilled, (state, action) => {
        state.elhaghiyehMenuContents.loading = false;
        if (action.payload !== undefined) {
          state.elhaghiyehMenuContents.data = action.payload;
        }
        return state;
      })
      .addCase(getElhaghiyehMenuContents.rejected, (state) => {
        state.elhaghiyehMenuContents.loading = false;
      });
  },
});

export default contentPageSlice.reducer;
